import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteStateJob, fetchAllJobs } from "../../features/FetchAllJobs/FetchAllJobsSlice";
import FilterSearchSort from "../FilterSearchSort/FilterSearchSort";
import JobList from "../JobList/JobList";

const AvailableJobs = () => {
  const dispatch = useDispatch();
  const { jobs, isLoading, isError, filterType, searchText } = useSelector(
    (state) => state.allJobs
  );

  useEffect(() => {
    dispatch(fetchAllJobs());
  }, [dispatch]);

  const { confirmation } = useSelector((state) => state.deleteConfirmation);

   useEffect(() => {
    if (confirmation) {
      dispatch(deleteStateJob(Number(confirmation)));
    }
  }, [dispatch, confirmation]);

  const handleSearchFilter = (job) => {
    if (searchText) {
      return job.title.toLowerCase().includes(searchText);
    }
    return true;
  }

  const handleTypeFilter = (job) => {
    if (filterType) {
      return job.type === filterType;
    }
    return true;
  };

  let content = null;
  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError)
    content = <p className="error">There was an error occured</p>;

  if (!isLoading && !isError && jobs?.length > 0) {
    content = jobs
      .filter(handleTypeFilter)
      .filter(handleSearchFilter)
      .map((job) => <JobList key={job.id} job={job}></JobList>);
  }

  if (!isLoading && !isError && jobs?.length === 0) {
    content = <p>No job found!</p>;
  }

  return (
    <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
        <h1 className="lws-section-title">All Available Jobs</h1>
        <FilterSearchSort></FilterSearchSort>
      </div>
      {content}
    </main>
  );
};

export default AvailableJobs;
